import Vue from "vue";
import CreativeGroupFormFormatDefinitionRepository from "@/repositories/monocle/CreativeGroupFormFormatDefinitionRepository";

export interface CreativeGroupFormatFormDefinition {
    uuid: string;
    label: string;
}

export default {
    state: {
        creativeGroupFormatFormDefinitions: [],
    },
    mutations: {
        setCreativeGroupFormatFormDefinitions: (
            state: any,
            creativeGroupFormatFormDefinitions: CreativeGroupFormatFormDefinition[]
        ) => {
            Vue.set(state, "creativeGroupFormatFormDefinitions", creativeGroupFormatFormDefinitions);
        },
    },
    getters: {
        getAllCreativeGroupFormatFormDefinitions: (state: any): CreativeGroupFormatFormDefinition[] => {
            return state.creativeGroupFormatFormDefinitions;
        },
    },
    actions: {
        loadCreativeGroupFormatFormDefinitions: ({ commit }: any) => {
            return new Promise((resolve: (value: object) => void, reject: (value: object) => void) => {
                CreativeGroupFormFormatDefinitionRepository.get().then((data: any) => {
                    commit("setCreativeGroupFormatFormDefinitions", data);
                    resolve(data);
                }).catch((reason: any) => {
                    reject(reason);
                });
            });
        },
    },
};
